import { DialogPosition, MatDialogConfig } from '@angular/material/dialog';
import { QaroniMatDialogAnimationToType } from './qaroni-mat-dialog-animation-to';
import { QaroniMatDialogConfigAnimate } from './qaroni-mat-dialog-config-animate';
import { QaroniMatDialogDirectionEnum } from './qaroni-mat-dialog-direction.enum';

export class QaroniDialogConfig<D> extends MatDialogConfig<D> {
  animation?: {
    to?: QaroniMatDialogAnimationToType;
    incomingOptions?: {
      keyframes?: Keyframe[];
      keyframeAnimationOptions?: KeyframeAnimationOptions;
    };
    outgoingOptions?: {
      keyframes?: Keyframe[];
      keyframeAnimationOptions?: KeyframeAnimationOptions;
    };
  };

  override position?: DialogPosition & { rowStart?: string; rowEnd?: string };

  constructor(matDialogConfigAnimate: QaroniMatDialogConfigAnimate) {
    super();
    this.setAnimations(matDialogConfigAnimate);
  }

  setAnimations(matDialogConfigAnimate: QaroniMatDialogConfigAnimate) {
    if (matDialogConfigAnimate?.animation && matDialogConfigAnimate?.position) {
      if (matDialogConfigAnimate?.position.rowEnd) {
        if (
          matDialogConfigAnimate.direction === QaroniMatDialogDirectionEnum.RTL
        ) {
          matDialogConfigAnimate.position.right =
            matDialogConfigAnimate?.position.rowEnd;
        } else {
          matDialogConfigAnimate.position.left =
            matDialogConfigAnimate?.position.rowEnd;
        }
      }

      if (matDialogConfigAnimate?.position.rowStart) {
        if (
          matDialogConfigAnimate.direction === QaroniMatDialogDirectionEnum.RTL
        ) {
          matDialogConfigAnimate.position.left =
            matDialogConfigAnimate?.position.rowEnd;
        } else {
          matDialogConfigAnimate.position.right =
            matDialogConfigAnimate?.position.rowEnd;
        }
      }
    }

    const config = { ...matDialogConfigAnimate };
    config.direction = QaroniMatDialogDirectionEnum.LTR;
    Object.assign(this, config);
  }
}
